import { LocalizedProperty, LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';
import { Product } from '@mews-commander/types';

interface SplitReservationDialogProps {
    active: boolean;
    onClose: () => void;
    nonProRatedAbsoluteProducts: Product[];
    onSplitReservation: () => void;
}

export const SplitReservationDialog = ({
    active,
    onClose,
    nonProRatedAbsoluteProducts,
    onSplitReservation,
}: SplitReservationDialogProps) => {
    const onSubmit = () => {
        onClose();
        onSplitReservation();
    };

    const footer = {
        primary: (
            <Button variant="primary" type="submit" size="medium" onClick={onSubmit}>
                {lt(TextKey.ReservationSplit)}
            </Button>
        ),
        secondary: (
            <Button variant="tertiary" type="button" size="medium" onClick={onClose}>
                {lt(TextKey.GoBack)}
            </Button>
        ),
    };

    const message =
        nonProRatedAbsoluteProducts.length === 1 ? (
            <LocalizedText
                textKey={TextKey.ReservationSplitFormInfoMessage}
                substitutes={{ product: <LocalizedProperty property={nonProRatedAbsoluteProducts[0].names} /> }}
            />
        ) : (
            <LocalizedText textKey={TextKey.ReservationSplitFormInfoMessagePlural} />
        );

    return (
        <Dialog
            active={active}
            onClose={onClose}
            size="small"
            title={lt(TextKey.ReservationSplitFormDialogTitle)}
            footer={footer}
        >
            {message}
        </Dialog>
    );
};
